<template>
    <div>

        <div class="vx-row">
            <div class="vx-col w-full">
                <vx-card titleIcon="EyeIcon" ref="filterCard" title="Summary" class="mb-8 user-list-filters"
                    :collapse-action="false">
                    <div class="vx-row">
                        <div class="vx-col w-1/5" style="line-height: 25px;">
                            <vs-list>
                                <vs-list-header title="FIRST CONTACT MADE"></vs-list-header>
                                <!-- <vs-list-item title="code" :subtitle="contact_summary.first.code"></vs-list-item>
                                <vs-list-item title="created by"
                                    :subtitle="contact_summary.first.created_by.name"></vs-list-item>
                                <vs-list-item title="created at"
                                    :subtitle="contact_summary.first.created_at_human"></vs-list-item> -->
                                Contact Event ID : {{ contact_summary.first.code }} <br>
                                Created By: {{ contact_summary.first.created_by.name }} <br>
                                Timeline: {{ contact_summary.first.created_at_human }}
                            </vs-list>
                        </div>
                        <div class="vx-col w-1/5" style="line-height: 25px;">
                            <vs-list>
                                <vs-list-header title="LAST CONTACT MADE"></vs-list-header>
                                <!-- <vs-list-item title="code" :subtitle="contact_summary.last.code"></vs-list-item>
                                <vs-list-item title="created by"
                                    :subtitle="contact_summary.last.created_by.name"></vs-list-item>
                                <vs-list-item title="created at"
                                    :subtitle="contact_summary.last.created_at_human"></vs-list-item> -->
                                Contact Event ID : {{ contact_summary.last.code }} <br>
                                Created By: {{ contact_summary.last.created_by.name }} <br>
                                Timeline: {{ contact_summary.last.created_at_human }}
                            </vs-list>
                        </div>
                        <div class="vx-col w-1/5 hidden">
                            <vs-list>
                                <vs-list-header title="LAST FOLLOW-UP"></vs-list-header>
                                <vs-list-item title="code" :subtitle="contact_summary.follow_up.last.code"></vs-list-item>
                                <vs-list-item title="created at"
                                    :subtitle="contact_summary.follow_up.last.created_at_human"></vs-list-item>
                                <vs-list-item title="follow-up timestamp"
                                    :subtitle="contact_summary.follow_up.last.follow_up_timestamp_human"></vs-list-item>
                            </vs-list>
                        </div>
                        <div class="vx-col w-1/5" style="line-height: 25px;">
                            <vs-list>
                                <vs-list-header title="NEXT FOLLOW-UP"></vs-list-header>
                                <!-- <vs-list-item title="code" :subtitle="contact_summary.follow_up.next.code"></vs-list-item>
                                <vs-list-item title="created at"
                                    :subtitle="contact_summary.follow_up.next.created_at_human"></vs-list-item>
                                <vs-list-item title="follow-up timestamp"
                                    :subtitle="contact_summary.follow_up.next.follow_up_timestamp_human"></vs-list-item> -->
                                Contact Event ID : {{ contact_summary.follow_up.next.code }} <br>
                                Timeline: {{ contact_summary.follow_up.next.created_at_human }} <br>
                                Followup Timestamp: {{ contact_summary.follow_up.next.follow_up_timestamp_human }}
                            </vs-list>
                        </div>
                        <div class="vx-col w-1/5">
                            <vs-list>
                                <vs-list-header title="NO OF USERS CONTACTED"></vs-list-header>
                                <vs-list-item :title="contact_summary.no_of_users_contacted + ''"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-header title="FREQUENCY OF CONTACT"> </vs-list-header>
                                <vs-list-item :title="contact_summary.frequency">
                                    <vs-icon @click.stop="activePrompt = true" icon-pack="feather" icon="icon-info"
                                        color="warning" size="20px" class="cursor-pointer" />
                                </vs-list-item>
                            </vs-list>
                        </div>
                    </div>
                </vx-card>
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col w-full">
                <vs-tabs position="top" id="customer-profile-tabs" class="w-full" alignment="center">
                    <vs-tab :label="tab.tab_name" v-for="(tab, tab_index) in contact_types" :key="`tab${tab_index}`">
                        <CustomerCrmContactList :contact_type="tab.type" v-on:refreshSummary="fetchContactSummary" />
                    </vs-tab>
                </vs-tabs>
            </div>
        </div>

        <vs-prompt :active.sync="activePrompt" :buttonsHidden="true" title="FREQUENCY INFO" color="warning">
            <div class="con-exemple-prompt">
                <p><span class="font-bold text-primary">1. High:</span> Less than 1 month between customer contact/events
                </p>
                <p><span class="font-bold text-warning">2. Medium:</span> 1 to 6 months between customer contact/events</p>
                <p><span class="font-bold text-danger">3. Low:</span> More than 6 months between customer contact/events</p>
            </div>
        </vs-prompt>
    </div>
</template>
<script>

import { RepositoryFactory } from '@/repository/RepositoryFactory';
const CrmRepository = RepositoryFactory.get('crm');
import CustomerCrmContactList from './CustomerCrmContactList.vue';

export default {
    name: 'CustomerCrmContactHome',
    data() {
        return {
            activePrompt: false,
            contact_types: [
                {
                    tab_name: 'EMAIL',
                    type: 'email',
                },
                {
                    tab_name: 'EVENT',
                    type: 'event',
                },
                {
                    tab_name: 'CALL',
                    type: 'call',
                },
                {
                    tab_name: 'F2F MEETING',
                    type: 'f2f-meeting',
                },
                {
                    tab_name: 'OTHER',
                    type: 'other',
                }
            ],
            contact_summary: {
                first: {
                    code: '',
                    created_at_human: '',
                    created_by: {
                        name: ''
                    }
                },
                last: {
                    code: '',
                    created_at_human: '',
                    created_by: {
                        name: ''
                    }
                },
                follow_up: {
                    last: {
                        follow_up_timestamp_human: '',
                        created_at_human: '',
                        code: ''
                    },
                    next: {
                        follow_up_timestamp_human: '',
                        created_at_human: '',
                        code: ''
                    },
                },
                no_of_users_contacted: '0',
                frequency: ''
            }
        }
    },
    components: {
        CustomerCrmContactList,
    },
    async mounted() {
        await this.fetchContactSummary()
    },
    methods: {
        async fetchContactSummary() {
            try {
                const { data } = await CrmRepository.viewCustomerCrmContactSummary(this.$route.params.id)
                this.contact_summary = data.data
            } catch (error) {

            }
        }
    },
}
</script>
<style lang="">
    
</style>